import { render } from "./DeviatingVehicleComposition.vue?vue&type=template&id=f590a986"
import script from "./DeviatingVehicleComposition.vue?vue&type=script&lang=ts"
export * from "./DeviatingVehicleComposition.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
